export const createMonths = () => {
  const months = {};
  for (let m = 1; m <= 12; m++) {
    months[m] = null;
  }

  return months;
};
